export const DOCUMENT_LABELS = {
    quotation: 'ใบเสนอราคา', invoice: 'ใบแจ้งหนี้ (Invoice)', receipt: 'ใบเสร็จรับเงิน',
};
/** A Drive file can have multiple URL spellings; display it only once. */
export function documentFileKey(url) {
    return url.match(/\/d\/([^/?#]+)/)?.[1] || url.match(/[?&]id=([^&#]+)/)?.[1] || url.trim();
}
export function mergeDocumentHistory(...groups) {
    const files = new Map();
    for (const row of groups.flat()) {
        if (!row.pdfUrl || !DOCUMENT_LABELS[row.type])
            continue;
        const key = documentFileKey(row.pdfUrl);
        const previous = files.get(key);
        files.set(key, { ...previous, ...row, createdAt: row.createdAt || previous?.createdAt || '', number: row.number || previous?.number || '' });
    }
    return [...files.values()];
}
/** True when a document of this type already exists for the same payment scope. */
export function hasDocumentVersionForScope(history, type, installmentId) {
    const scope = String(installmentId || '');
    return history.some((doc) => doc.type === type && String(doc.installmentId || '') === scope);
}
export function getJobDocumentHistory(job) {
    let history = [];
    try {
        const data = typeof job['Document History'] === 'string' ? JSON.parse(job['Document History'] || '[]') : job['Document History'];
        if (Array.isArray(data))
            history = data.filter((r) => r && DOCUMENT_LABELS[r.type] && typeof r.pdfUrl === 'string').map((r) => ({ type: r.type, pdfUrl: r.pdfUrl.trim(), number: String(r.number || ''), createdAt: String(r.createdAt || ''), ...(r.paymentId ? { paymentId: String(r.paymentId) } : {}), ...(r.installmentId ? { installmentId: String(r.installmentId) } : {}) }));
    }
    catch { /* Legacy jobs have only their latest URL fields. */ }
    const latest = ['quotation', 'invoice', 'receipt'].flatMap((type) => {
        const prefix = type[0].toUpperCase() + type.slice(1);
        const url = String(job[`${prefix} PDF URL`] || '').trim();
        return url ? [{ type, number: String(job[`${prefix} Number`] || ''), pdfUrl: url, createdAt: '' }] : [];
    });
    return mergeDocumentHistory(history, latest);
}
//# sourceMappingURL=document-history.js.map